import { FormInputField, lt } from '@mews/framework';
import { WithAccountId } from '@mews-commander/types';
import { PaymentRequestFormField } from '../schema';
import { useGetAccountEmailSuspense } from '../../queries';

export const PaymentRequestFormEmailField = ({ accountId }: WithAccountId) => {
    const { data: email } = useGetAccountEmailSuspense({ accountId });

    return (
        <FormInputField
            required
            name={PaymentRequestFormField.Email}
            label={lt('Email')}
            defaultValue={email ?? ''}
            helper={lt('ProcessPaymentPaymentRequestEmailHelper')}
        />
    );
};
